// GraphQL queries for HR Dashboard

export const getHRDashboardData = /* GraphQL */ `
  query GetHRDashboardData($companyId: String!, $userEmail: String!) {
    getHRDashboardData(companyId: $companyId, userEmail: $userEmail) {
      totalFlags
      totalThreads
      employeeCount
      activeUserCount
      employeeUptakePercentage
      outsideBusinessHoursPercentage
      departmentBreakdown
      departments
      flags {
        flagId
        category
        severity
        status
        summary
        createdAt
        isAnonymous
        userEmail
        userName
        userId
        department
      }
      reporters {
        userId
        userName
        userEmail
        isAnonymous
        flagCount
      }
    }
  }
`

export const getCompanyForHREmail = /* GraphQL */ `
  query GetCompanyForHREmail($email: String!) {
    getCompanyForHREmail(email: $email) {
      companyId
    }
  }
`

export const getFlagDetails = /* GraphQL */ `
  query GetFlagDetails($flagId: ID!) {
    getFlagDetails(flagId: $flagId) {
      flagId
      category
      severity
      status
      summary
      createdAt
      isAnonymous
      userEmail
      userName
      userId
      department
      notes {
        noteId
        authorEmail
        authorName
        content
        createdAt
        updatedAt
      }
      statusHistory {
        historyId
        oldStatus
        newStatus
        changedBy
        changedByName
        changedAt
        notes
      }
    }
  }
`

export const getHRFlags = /* GraphQL */ `
  query GetHRFlags($companyId: String!) {
    getHRFlags(companyId: $companyId) {
      flagId
      category
      severity
      status
      summary
      createdAt
      isAnonymous
      userEmail
      userName
      userId
      department
      notes {
        noteId
        authorEmail
        authorName
        content
        createdAt
        updatedAt
      }
      statusHistory {
        historyId
        oldStatus
        newStatus
        changedBy
        changedByName
        changedAt
        notes
      }
    }
  }
`

export const listThreads = /* GraphQL */ `
  query ListThreads($companyId: String!) {
    listThreads(companyId: $companyId) {
      threadId
      userId
      companyId
      threadName
      pool
      status
      createdAt
      lastMessageAt
    }
  }
`

export const getThreadsByPool = /* GraphQL */ `
  query GetThreadsByPool($companyId: String!, $userEmail: String!) {
    getThreadsByPool(companyId: $companyId, userEmail: $userEmail) {
      coaching
      mediation
      hrEscalation
      total
    }
  }
`

export const getAnalyticsData = /* GraphQL */ `
  query GetAnalyticsData($companyId: String!, $userEmail: String!) {
    getAnalyticsData(companyId: $companyId, userEmail: $userEmail) {
      threads {
        threadId
        userId
        pool
        status
        createdAt
        lastMessageAt
        resolvedAt
        department
      }
      flags {
        flagId
        userId
        status
        createdAt
        department
      }
      departmentMap
    }
  }
`

